import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDog = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.966,21.537H4.031a71.008,71.008,0,0,1-1.467-8.8A3.669,3.669,0,0,1,6.232,9.065h6.6a1.853,1.853,0,0,0,1.752-.913",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.237,5.764c0,1.418.367,2.568-1.468,2.568S13.568,7.6,14.3,5.4c.447-1.34.87-2.934,3.668-2.934a3.272,3.272,0,0,1,2.935,2.2l2.2.733s.825,4.081-2.935,3.668c-.733,2.935,0,5.136-2.2,6.6v5.869h1.468",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.634,13.467s0,2.935-3.668,2.935L6.11,21.537",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.97 21.537L15.036 21.537 14.302 15.668 12.835 15.668",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.3,10.533S-.371,9.8,1.1,5.4",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgDog;
